<template lang="pug">
#app 
   router-view(:key="$route.fullPath")
</template>

<script>
export default {
   name: 'App',
   metaInfo() {
      return {
         title: 'Good Remote ∙ Dashboard',
         titleTemplate: '%s ∙ Good Remote',
      }
   },
}
</script>
